'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (YotpoReviews, $) {
    var YotpoReviewsInit = function YotpoReviewsInit() {
      if ($('.yotpo-nav-tab.yotpo-active').attr('data-type') == 'reviews') {
        $('.write-question-button').hide();
        $('.write-review-button').show();
      } else if ($('.yotpo-nav-tab.yotpo-active').attr('data-type') == 'questions') {
        $('.write-review-button').hide();
        $('.write-question-button').show();
      }
    };

    var bindUIActions = function bindUIActions() {
      $('body').on('click', '.yotpo-nav-tab', function () {
        YotpoReviewsInit();
      });
    };

    YotpoReviews.init = function () {
      bindUIActions();
    };
  })(window.YotpoReviews = window.YotpoReviews || {}, _jquery2.default, undefined);
};